module.exports = __webpack_public_path__ + "media/application/images/img/overlays/06-21612b9d3e9d84e7e8761a2caf43bc65.png";